import axios from 'axios'
const __axios = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

export default __axios
